import { Pending, QueryOp } from "@indietabletop/appkit";
import { createContext, useContext } from "react";

export const ArmiesRulesetsContext = createContext<QueryOp<Set<string>>>(new Pending());

export function useArmiesRulesets() {
  return useContext(ArmiesRulesetsContext);
}
